// src/lib/supabase.js
// Replace REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: false,  // Session is NOT saved to localStorage — clears on tab/app close
    detectSessionInUrl: true
  }
});

// Sign out when tab/window is closed
window.addEventListener('beforeunload', () => {
  supabase.auth.signOut();
});

// Rate limit tracking per provider
export const API_LIMITS = {
  yahoo_finance: {
    name: 'Yahoo Finance',
    daily_limit: 2000,
    per_minute_limit: 60,
    description: 'Free tier via yfinance-compatible endpoint'
  },
  alpha_vantage: {
    name: 'Alpha Vantage',
    daily_limit: 25,
    per_minute_limit: 5,
    description: 'Free tier: 25 calls/day, 5/min'
  },
  openfigi: {
    name: 'OpenFIGI (Identifier Lookup)',
    daily_limit: 250,
    per_minute_limit: 25,
    description: 'Free tier: 250 requests/day'
  },
  french_data: {
    name: 'Ken French Data Library',
    daily_limit: 10,
    per_minute_limit: 2,
    description: 'Free academic factor data'
  }
};
